import { render } from "./UserTap.vue?vue&type=template&id=385ee852"
import script from "./UserTap.vue?vue&type=script&lang=js"
export * from "./UserTap.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__